(function () {
  'use strict';
  const instances = new WeakMap();
  const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }
  function price(cents) { return money.format(cents / 100); }
  function paw(check) {
    return '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false"><g class="' + (check ? 'pack-paw-shape' : '') + '"><ellipse cx="32" cy="43" rx="16" ry="12"/><ellipse cx="10" cy="27" rx="6" ry="8" transform="rotate(-26 10 27)"/><ellipse cx="23" cy="14" rx="6" ry="8" transform="rotate(-13 23 14)"/><ellipse cx="40" cy="13" rx="6" ry="8" transform="rotate(13 40 13)"/><ellipse cx="54" cy="26" rx="6" ry="8" transform="rotate(26 54 26)"/></g>' + (check ? '<path class="pack-paw-check" d="m24 43 5 5 11-11"/>' : '') + '</svg>';
  }
  function variants(product) {
    if (Array.isArray(product.variants) && product.variants.length) return product.variants;
    return [{ id: product.id || '', title: product.variantTitle || '', color: product.color || '', priceCents: product.priceCents, image: product.image, available: product.available !== false }];
  }
  function variantPrice(variant, product) {
    const value = variant.priceCents == null ? product.priceCents : variant.priceCents;
    const cents = Number(value);
    return Number.isFinite(cents) && cents >= 0 ? Math.round(cents) : 0;
  }
  function image(variant, product) { return variant.image || product.image || ''; }
  function variantCompareAt(variant, product) {
    const value = Object.prototype.hasOwnProperty.call(variant, 'compareAtCents') ? variant.compareAtCents : product.compareAtCents;
    const cents = Number(value);
    return Number.isFinite(cents) && cents > 0 ? Math.round(cents) : 0;
  }
  function savingPercent(currentCents, compareCents) {
    return currentCents > 0 && compareCents > currentCents ? Math.round((compareCents - currentCents) / compareCents * 100) : 0;
  }
  function canAddItems(items, variants) {
    const quantities = new Map();
    for (const item of items) {
      const quantity = Number(item.quantity);
      if (!Number.isInteger(quantity) || quantity < 1) return false;
      const id = String(item.id);
      quantities.set(id, (quantities.get(id) || 0) + quantity);
    }
    for (const [id, quantity] of quantities) {
      const matching = variants.filter(function (variant) { return String(variant.id) === id; });
      if (!matching.length) return false;
      for (const variant of matching) {
        if (variant.available === false) return false;
        if (variant.maxQuantity != null) {
          const maximum = Number(variant.maxQuantity);
          if (!Number.isFinite(maximum) || quantity > maximum) return false;
        }
      }
    }
    return quantities.size > 0;
  }
  function mount(root, config) {
    if (!root || !config || !config.primary || !config.companion) return null;
    if (instances.has(root)) return instances.get(root);
    const primaryVariants = variants(config.primary);
    const companionVariants = variants(config.companion);
    const availableCompanions = companionVariants.filter(function (variant) { return variant.available !== false; });
    const preferredPrimary = primaryVariants.find(function (variant) { return String(variant.id) === String(config.primaryVariantId); });
    const preferredCompanion = availableCompanions.find(function (variant) { return String(variant.id) === String(config.companionVariantId); });
    let primaryVariant = preferredPrimary || primaryVariants[0];
    let companionVariant = preferredCompanion || availableCompanions[0] || companionVariants[0];
    let selected = 'single';
    const discountPercent = Math.max(0, Math.min(100, Number(config.discountPercent) || 0));
    const id = String(config.id || 'kitteen').replace(/[^a-zA-Z0-9_-]/g, '-');
    const group = id + '-formula';
    const hasChoice = companionVariants.length > 1;
    const optionLabel = config.companionOptionLabel || 'Coloris du complément';
    root.classList.add('kitteen-pack-formulas');
    root.setAttribute('data-kitteen-pack-formulas', '');
    const card = function (isPack) {
      return '<label class="kitteen-pack-card ' + (isPack ? 'kitteen-pack-bundle' : 'is-selected') + '" data-pack-card="' + (isPack ? 'pack' : 'single') + '">' +
        '<input class="kitteen-pack-radio" type="radio" name="' + esc(group) + '" value="' + (isPack ? 'pack' : 'single') + '" ' + (isPack ? (availableCompanions.length ? '' : 'disabled') : 'checked') + '>' +
        '<span class="kitteen-pack-visual' + (isPack ? ' kitteen-pack-duo' : '') + '" aria-hidden="true"><img data-pack-primary-image src="' + esc(image(primaryVariant, config.primary)) + '" alt="">' +
        (isPack ? '<img data-pack-companion-image src="' + esc(image(companionVariant, config.companion)) + '" alt="">' : '') + '</span>' +
        '<span class="kitteen-pack-copy"><strong>' + esc(isPack ? config.packName : (config.singleLabel || 'Produit seul')) + '</strong><span>' + esc(isPack ? config.packDescription : (config.primary.shortTitle || config.primary.title)) + '</span></span>' +
        '<span class="kitteen-pack-end"><span class="kitteen-pack-paw" aria-hidden="true">' + paw(true) + '</span><span class="kitteen-pack-prices"><strong class="kitteen-pack-price" data-pack-price="' + (isPack ? 'pack' : 'single') + '"></strong><span class="kitteen-pack-savings" data-pack-savings="' + (isPack ? 'pack' : 'single') + '" hidden><s class="kitteen-pack-compare" data-pack-compare="' + (isPack ? 'pack' : 'single') + '" aria-label="Prix avant remise"></s><span class="kitteen-pack-discount" data-pack-discount="' + (isPack ? 'pack' : 'single') + '"></span></span></span></span></label>';
    };
    root.innerHTML = '<legend><span class="kitteen-pack-legend-paw" aria-hidden="true">' + paw(false) + '</span>Choisissez votre formule</legend>' +
      '<div class="kitteen-pack-options">' + card(false) + card(true) + '</div>' +
      (hasChoice ? '<div class="kitteen-pack-controls" data-pack-controls hidden><label for="' + esc(id + '-companion') + '">' + esc(optionLabel) + '</label><select id="' + esc(id + '-companion') + '" data-pack-companion aria-label="' + esc(optionLabel) + '">' +
        companionVariants.map(function (variant) {
          return '<option value="' + esc(variant.id) + '"' + (variant.available === false ? ' disabled' : '') + (String(variant.id) === String(companionVariant.id) ? ' selected' : '') + '>' + esc(variant.color || variant.title) + (variant.available === false ? ' — indisponible' : '') + '</option>';
        }).join('') + '</select></div>' : '') +
      '<span class="kitteen-pack-status" data-pack-status role="status" aria-live="polite"></span>';
    const radios = Array.from(root.querySelectorAll('.kitteen-pack-radio'));
    const cards = Array.from(root.querySelectorAll('[data-pack-card]'));
    const select = root.querySelector('[data-pack-companion]');
    function detail() {
      const primaryCents = variantPrice(primaryVariant, config.primary);
      const companionCents = variantPrice(companionVariant, config.companion);
      const undiscountedCents = primaryCents + companionCents;
      const packCents = Math.round(undiscountedCents * (1 - discountPercent / 100));
      const singleCompareCents = variantCompareAt(primaryVariant, config.primary);
      const packCompareCents = discountPercent > 0 ? Math.max(primaryCents, singleCompareCents) + Math.max(companionCents, variantCompareAt(companionVariant, config.companion)) : 0;
      const items = [{ id: primaryVariant.id, quantity: 1 }];
      if (selected === 'pack') items.push({ id: companionVariant.id, quantity: 1 });
      return {
        selected: selected,
        formula: selected,
        items: items,
        totalCents: selected === 'pack' ? packCents : primaryCents,
        packCents: packCents,
        singleCents: primaryCents,
        singleCompareCents: singleCompareCents,
        packCompareCents: packCompareCents,
        singleSavingPercent: savingPercent(primaryCents, singleCompareCents),
        packSavingPercent: savingPercent(packCents, packCompareCents),
        undiscountedCents: undiscountedCents,
        discountPercent: discountPercent,
        primaryVariant: Object.assign({}, primaryVariant),
        companionVariant: Object.assign({}, companionVariant),
        primaryColor: primaryVariant.color || primaryVariant.title || '',
        companionColor: companionVariant.color || companionVariant.title || '',
        packName: config.packName,
        canAdd: canAddItems(items, [primaryVariant, companionVariant])
      };
    }
    function update() {
      const state = detail();
      cards.forEach(function (current) { current.classList.toggle('is-selected', current.dataset.packCard === selected); });
      radios.forEach(function (radio) { radio.checked = radio.value === selected; });
      root.querySelector('[data-pack-card="pack"]').classList.toggle('is-disabled', !availableCompanions.length);
      root.querySelector('[data-pack-price="single"]').textContent = price(state.singleCents);
      root.querySelector('[data-pack-price="pack"]').textContent = price(state.packCents);
      ['single', 'pack'].forEach(function (formula) {
        const percent = formula === 'single' ? state.singleSavingPercent : state.packSavingPercent;
        const compareCents = formula === 'single' ? state.singleCompareCents : state.packCompareCents;
        root.querySelector('[data-pack-savings="' + formula + '"]').hidden = percent <= 0;
        root.querySelector('[data-pack-compare="' + formula + '"]').textContent = percent > 0 ? price(compareCents) : '';
        root.querySelector('[data-pack-discount="' + formula + '"]').textContent = percent > 0 ? '−' + percent + ' %' : '';
      });
      root.querySelectorAll('[data-pack-primary-image]').forEach(function (element) { element.src = image(primaryVariant, config.primary); });
      root.querySelector('[data-pack-companion-image]').src = image(companionVariant, config.companion);
      const controls = root.querySelector('[data-pack-controls]');
      if (controls) controls.hidden = selected !== 'pack';
      root.querySelector('[data-pack-status]').textContent = !availableCompanions.length ? 'Le pack est actuellement indisponible.' : '';
      root.dispatchEvent(new CustomEvent('kitteen:formula-change', { bubbles: true, detail: state }));
      return state;
    }
    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('kitteen-pack-radio')) selected = event.target.value;
      else if (event.target === select) companionVariant = companionVariants.find(function (variant) { return String(variant.id) === select.value; }) || companionVariant;
      else return;
      update();
    });
    root.addEventListener('keydown', function (event) {
      const enabled = radios.filter(function (radio) { return !radio.disabled; });
      const index = enabled.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % enabled.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + enabled.length) % enabled.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = enabled.length - 1;
      else return;
      event.preventDefault();
      selected = enabled[next].value;
      enabled[next].focus();
      update();
    });
    const api = {
      getState: detail,
      setPrimaryVariant: function (variantId) {
        const variant = primaryVariants.find(function (current) { return String(current.id) === String(variantId); });
        if (!variant) return false;
        primaryVariant = variant;
        update();
        return true;
      },
      setCompanionVariant: function (variantId) {
        const variant = companionVariants.find(function (current) { return String(current.id) === String(variantId) && current.available !== false; });
        if (!variant) return false;
        companionVariant = variant;
        if (select) select.value = String(variant.id);
        update();
        return true;
      },
      selectFormula: function (formula) {
        if (formula !== 'single' && formula !== 'pack') return false;
        if (formula === 'pack' && !availableCompanions.length) return false;
        selected = formula;
        update();
        return true;
      },
      refresh: update
    };
    instances.set(root, api);
    root.hidden = false;
    update();
    return api;
  }
  function init(root) {
    if (!root) return null;
    if (instances.has(root)) return instances.get(root);
    const script = root.querySelector('script[data-pack-config]');
    if (!script) return null;
    try { return mount(root, JSON.parse(script.textContent)); }
    catch (error) { console.error('Kitteen pack configuration: ', error); return null; }
  }
  function initAll() { document.querySelectorAll('[data-kitteen-pack-formulas]').forEach(init); }
  window.KitteenPackFormulas = {
    init: init,
    mount: mount,
    initAll: initAll,
    canAddItems: canAddItems,
    get: function (root) { return instances.get(root) || null; },
    setPrimaryVariant: function (root, variantId) {
      const instance = instances.get(root) || init(root);
      return instance ? instance.setPrimaryVariant(variantId) : false;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
}());
